export default __webpack_public_path__ + "static/media/Who-We-Serve.36e72a01.jpg";